import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { OnboardingData, ChatMessageProps } from '../types';

interface OnboardingState {
  data: Partial<OnboardingData>;
  currentStep: number;
  messages: ChatMessageProps[];
  currentQuestionIndex: number;
}

const initialState: OnboardingState = {
  data: {},
  currentStep: 0,
  messages: [],
  currentQuestionIndex: 0,
};

export const onboardingSlice = createSlice({
  name: 'onboarding',
  initialState,
  reducers: {
    updateOnboardingData: (
      state,
      action: PayloadAction<Partial<OnboardingData>>
    ) => {
      state.data = { ...state.data, ...action.payload };
    },
    setZipCode: (state, action: PayloadAction<string>) => {
      state.data.zip_code = action.payload;
    },
    setCensusTract: (state, action: PayloadAction<string>) => {
      state.data.census_tract = action.payload;
    },
    // TODO: Uncomment when tract center data is needed again
    // setTractCenter: (
    //   state,
    //   action: PayloadAction<{ lat: number; lng: number }>
    // ) => {
    //   state.data.tract_center_lat = action.payload.lat;
    //   state.data.tract_center_lng = action.payload.lng;
    // },
    // setTractCenterLat: (state, action: PayloadAction<number>) => {
    //   state.data.tract_center_lat = action.payload;
    // },
    // setTractCenterLng: (state, action: PayloadAction<number>) => {
    //   state.data.tract_center_lng = action.payload;
    // },
    setCurrentStep: (state, action: PayloadAction<number>) => {
      state.currentStep = action.payload;
    },
    setMessages: (state, action: PayloadAction<ChatMessageProps[]>) => {
      state.messages = action.payload;
    },
    setCurrentQuestionIndex: (state, action: PayloadAction<number>) => {
      state.currentQuestionIndex = action.payload;
    },
    resetOnboarding: (state) => {
      state.data = {};
      state.currentStep = 0;
      state.messages = [];
      state.currentQuestionIndex = 0;
    },
  },
});

export const {
  updateOnboardingData,
  setZipCode,
  setCensusTract,
  // TODO: Uncomment when tract center data is needed again
  // setTractCenter,
  // setTractCenterLat,
  // setTractCenterLng,
  setCurrentStep,
  setMessages,
  setCurrentQuestionIndex,
  resetOnboarding,
} = onboardingSlice.actions;

export default onboardingSlice.reducer;
